/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "QBwfaul1-d0",
    title: "One piece - I am Dangerousᴴᴰ",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "Ch-ytWO7Vts",
    title: "Inosuke Hashibira - Finish Line",
    anime: "demon slayer",
    category: "demonSlayer",
  },
  {
    _id: "ixbZ44uYXUA",
    title: "naruto AMV all",
    anime: "naruto",
    category: "naruto",
  },
  {
    _id: "BNiVl0bAhsQ",
    title: "One Piece - Centuries",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "xylh_sJAYdc",
    title: "One Piece | The Greatest Story Ever Told",
    anime: "one piece",
    category: "onePiece",
  },

  {
    _id: "Yb9T5VtMOdc",
    title: "One Piece-Imagine Dragons | Enemy",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "hBEX7UIq2k8",
    title: "One Piece - Royalty",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "fc9jd5tsI9E",
    title: "One Piece AMV | Human",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "-lo3d0mvn88",
    title: "One Piece - ZORO - Natural",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "wa9BxswPj-U",
    title: "Itadori Yuji & Ryomen Sukuna",
    anime: "jujutsu kaisen",
    category: "jujutsuKaisen",
  },
  {
    _id: "CuvRbljK7Ts",
    title: "Jujutsu Kaisen - Gojo Satoru",
    anime: "jujutsu kaisen",
    category: "jujutsuKaisen",
  },
  {
    _id: "GBlb9Lx4a4Q",
    title: "Jujutsu Kaisen [AMV] - INDUSTRY BABY",
    anime: "jujutsu kaisen",
    category: "jujutsuKaisen",
  },
  {
    _id: "WMzoYevzhU0",
    title: "One Piece | East Blue Saga | Counting Stars",
    anime: "one piece",
    category: "onePiece",
  },
  {
    _id: "qDuFSniBOuQ",
    title: "imagine dragons x J.I.D, Enemy - Jujutsu Kaisen Edit",
    anime: "jujutsu kaisen",
    category: "jujutsuKaisen",
  },
  {
    _id: "AFSFkhAZ3kA",
    title: "DEMON SLAYER- THE SEARCH [AMV]",
    anime: "demon slayer",
    category: "demonSlayer",
  },
  {
    _id: "p8uT9y4cPwY",
    title: "Demon Slayer - Rengoku vs Akaza",
    anime: "demon slayer",
    category: "demonSlayer",
  },
  {
    _id: "b04X9udG7cA",
    title: "Demon Slayer || Unstoppable",
    anime: "demon slayer",
    category: "demonSlayer",
  },
  {
    _id: "7iSUlVtLpPM",
    title: "Zenitsu Agatsuma - Honed to Perfection",
    anime: "demon slayer",
    category: "demonSlayer",
  },
  {
    _id: "H0_bKB9nPdY",
    title: "best duo | NF - The Search",
    anime: "jujutsu kaisen",
    category: "jujutsuKaisen",
  },
  {
    _id: "VcRrgG1d9K8",
    title: "Enemy (Baryon Naruto vs Isshiki)",
    anime: "naruto",
    category: "naruto",
  },
  {
    _id: "0bjicmknkVw",
    title: "The Tale of 7th Hokage Naruto Uzumaki",
    anime: "naruto",
    category: "naruto",
  },
  {
    _id: "azhzBF--Gw4",
    title: "A Failure's True Power",
    anime: "naruto",
    category: "naruto",
  },

  {
    _id: "DI5d-TrmIYw",
    title: "Guy VS Madara AMV",
    anime: "naruto",
    category: "naruto",
  },
  {
    _id: "Z6wP5eMNykE",
    title: "The Strongest of All",
    anime: "naruto",
    category: "naruto",
  },
  {
    _id: "7RUylQDHQMk",
    title: "Itachi Uchiha - Impossible",
    anime: "naruto",
    category: "naruto",
  },
  {
    _id: "-LEl83konr4",
    title: "Demon Slayer - Blood // Water",
    anime: "demon slayer",
    category: "demonSlayer",
  },
];
